export class RemoveOrganizationLicenseRequest {
    customerIds: number[] = [];
    inApp: boolean = true;
}